import {Api}from '../../components/Api';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from 'moment';
import { TICKET_CETAGORY_BY_COMPANY_FAILURE, TICKET_CETAGORY_BY_COMPANY_REQUEST, TICKET_CETAGORY_BY_COMPANY_SUCCESS, TICKET_REPORT, TICKET_REPORT_FAILURE, TICKET_REPORT_REQUEST, TICKET_REPORT_SUCCESS } from './types';
toast.configure();

export const ticketListReport = (data: any) => async (dispatch: any) => {
  try {
    dispatch({ type: TICKET_REPORT_REQUEST });

    const token = sessionStorage.getItem('token');
    if (!token) throw new Error("No authentication token found");

    const response = await Api.post('/tickets/ticketReport', data, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (response.data.success) {
      dispatch({
        type: TICKET_REPORT_SUCCESS,
        payload: response.data.successResponse,
      });
    } else {
      throw new Error(response.data.message || "Unknown error occurred");
    }
  } catch (err: any) {
    const message =
      err.response?.data?.message || err.message || "An unexpected error occurred";

    dispatch({ type: TICKET_REPORT_FAILURE, payload: message });

    toast.error(message, {
      position: toast.POSITION.TOP_RIGHT,
      hideProgressBar: true,
      autoClose: 3000,
    });
  }
};


export const ticketCetagoryByCompany = (data: any) => async (dispatch: any) => {
  try {
    dispatch({ type: TICKET_CETAGORY_BY_COMPANY_REQUEST });

    const token = sessionStorage.getItem("token");
    if (!token) throw new Error("No authentication token found");

    const response = await Api.post(`/tickets/ticketCategoryReportByCompanies`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (response.data.success) {
      dispatch({
        type: TICKET_CETAGORY_BY_COMPANY_SUCCESS,
        payload: response.data.successResponse,
      });
    } else {
      throw new Error(response.data.message || "Unknown error occurred");
    }
  } catch (err: any) {
    const message =
      err.response?.data?.message || err.message || "An unexpected error occurred";

    dispatch({ type: TICKET_CETAGORY_BY_COMPANY_FAILURE, payload: message });

    toast.error(message, {
      position: toast.POSITION.TOP_RIGHT,
      hideProgressBar: true,
      autoClose: 3000,
    });
  }
};

export const customersReport = (data: any, page: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.post(`/reports/customers/${page}`, data, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    dispatch({
                        //type: CUSTOMERS_REPORTS,
                        payload: response.data.successResponse,
                        currentPage: response.data.currentPage,
                        pageCount: response.data.pageCount,
                        numOfRows: response.data.numOfRows,
                        msg: ""
                    })
                }
            }).catch(err => {
                if (err.response) {
                    toast.error("No data to report", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
                    console.log(err.response.data.message)
                    dispatch({
                        // type: CUSTOMERS_REPORTS,
                        payload: [],
                        currentPage: 0,
                        pageCount: 0,
                        numOfRows: 0,
                        msg: ""
                    })
                } else {
                    alert(err.message)
                }
            });
    }
}
export const pmixReport = (data: any, page: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.post(`/reports/pmix_report/${page}`, data, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    dispatch({
                        // type: PMIX_REPORTS,
                        payload: response.data.successResponse,
                        currentPage: response.data.currentPage,
                        pageCount: response.data.pageCount,
                        numOfRows: response.data.numOfRows,
                        msg: ""
                    })
                }
            }).catch(err => {
                if (err.response) {
                    toast.error("No data to report", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
                    dispatch({
                        // type: PMIX_REPORTS,
                        payload: [],
                        currentPage: 0,
                        pageCount: 0,
                        numOfRows: 0,
                        msg: ""
                    })
                } else {
                    alert(err.message)
                }
            });
    }
}

